import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=d9df05ca&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9df05ca",
  null
  
)

/* custom blocks */
import block0 from "./Footer.vue?vue&type=custom&index=0&blockType=div&class=container-fluid%20m-3%20centered-on-page"
if (typeof block0 === 'function') block0(component)

export default component.exports